import "@/javascript/initSentry";
import "@/javascript/initStaleAssetsReload";
import "@rails/request.js";
import jQuery from "@/javascript/initJquery";
import "bootstrap";
import "@/javascript/vendor/bootstrap-datepicker";
import "@/javascript/vendor/bootstrap-datepicker.sv";
import "@/javascript/initializers";
import "@/javascript/tooltip";
import "@/javascript/displayToggle";

import initDataTables from "@/javascript/initDataTables";

import "@/javascript/facility";
import "@/javascript/confirmDeleteModal";
import "@/javascript/message_dismissal";
import "@/javascript/addActionToProjectModal";
import "@/javascript/removeActionFromProjectModal";

import "@/javascript/initTurbo";
import "@/javascript/initReactUjs";
import "@/javascript/initStimulus";
import "@/javascript/initInertia";

initDataTables(jQuery);

window.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-clear-filters]").forEach((element) => {
    element.addEventListener("click", () => localStorage.clear());
  });
});
